/**
 * W97 — Hint-Diät (V6-Audit Agent 1, P0): Das ⓘ im Card-Header.
 *
 * Vorher stand in 10+ Cards derselbe statische Erklär-Absatz bei JEDEM
 * Besuch im Sichtfeld („CARD_HINT-Befall"). Jetzt: Karte zeigt Daten,
 * die Erklärung steht hinter diesem Icon — lesbar, wenn man sie braucht,
 * unsichtbar, wenn man sie kennt.
 */
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { HoverTooltip } from '@/components/ui/hover-tooltip';

export function CardInfoIcon({ hint, widthRem = 24 }: { hint: ReactNode; widthRem?: number }) {
  return (
    <HoverTooltip
      align="left"
      widthRem={widthRem}
      content={<div className="text-[11px] text-zinc-300 leading-relaxed">{hint}</div>}
    >
      <span
        className="inline-flex items-center justify-center text-zinc-500 hover:text-zinc-300 cursor-help align-middle"
        aria-label="Was zeigt diese Karte?"
      >
        <Info className="size-3.5" />
      </span>
    </HoverTooltip>
  );
}
